import { useNavigate, useParams } from 'react-router';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { getFloorIds, getFloors } from 'src/utils/projectTreeAdapterForOfferPage';
import { LightingCalcTransfer } from 'src/components/Planner/planner/lightingCalc';
import { floorApiSlice } from 'src/api/v1/floor-ApiSlice';
import { AppDispatch, RootState, store } from 'src/app/store';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { useGetMeasurementSystemQuery, useGetProjectQuoteUserPropertiesQuery } from 'src/api/v1/project-ApiSlice';
import { useGetAuthKeyQuery } from 'src/api/auth-token-ApiSlice';
import { useGetVersionQuery } from 'src/api/app-ApiSlice';
import {
  useCableListQuery,
  useGetGroupedElementsQuery,
  useGetNHCPinoutDevicesQuery,
  useGetQuoteCustomItemRecommendationQuery,
  useGetQuoteDataQuery,
  useGetQuoteQuery,
  useGetRoutingLinesQuery,
  useInstallationCablingQuery,
  useSaveGroupNameByUgroupIdMutation
} from 'src/api/v1/quote-ApiSlice';
import { useGetProjectTreeProjectQuery, useGetProjectTreeQuery } from 'src/api/v1/get-project-tree-ApiSlice';
import { QuoteConverter } from 'src/utils/QuoteConverter';
import { deepCopy } from 'src/utils/controllerAdapterForOfferPage';
import { getTablesNewFormat } from 'src/pages/OfferPage/TableSvgOrganizer/tableSvgOrganizerUtils';
import { calculateLabourCost, getBomRows } from 'src/pages/OfferPage/DocuBom/DocuBomUtils';
import { DocuSectionButtons } from 'src/pages/OfferPage/DocuSectionButtons/DocuSectionButtons';
import { QuoteHeader } from 'src/pages/OfferPage/QuoteHeader/QuoteHeader';
import { CoverPage } from 'src/pages/OfferPage/CoverPage/CoverPage';
import { QuoteGeneralInfo } from 'src/pages/OfferPage/QuoteGeneralInfo/QuoteGeneralInfo';
import { useGetCoverImagesQuery } from 'src/api/v1/offer-ApiSlice';
import { TableSvgOrganizer } from 'src/pages/OfferPage/TableSvgOrganizer/TableSvgOrganizer';
import { FunctionDescription } from 'src/pages/OfferPage/FunctionDescription/FunctionDescription';
import { NHCPinout } from 'src/pages/OfferPage/pinouts/NHCPinout/NHCPinout';
import { Pinout } from 'src/pages/OfferPage/pinouts/Pinout/Pinout';
import { NHCBusPinout } from 'src/pages/OfferPage/pinouts/NHCBusPinout';
import { GroupedElementsList } from 'src/pages/OfferPage/pinouts/GroupedElementsList';
import { CableLabel } from 'src/pages/OfferPage/CableLabel/CableLabel';
import { DocuBom } from 'src/pages/OfferPage/DocuBom/DocuBom';
import { NonRoomTable } from 'src/pages/OfferPage/TableSvgOrganizer/NonRoomTable';
import { useFeatureFlagQuery, useIsBelgianUserQuery } from 'src/api/v1/feature-ApiSlice';
import { ProjectName } from 'src/pages/OfferPage/ProjectName/ProjectName';
import { convertToPinoutData, getNetworkDevices, PinoutData } from 'src/pages/OfferPage/pinouts/PinoutConverter';
import {
  GetFloorRoomsAndRelatedObjectsResponse,
  GetFloorRoomsDevice,
  InstallationCablingResponse
} from "src/model/api/v2/data-contracts";
import { NHCPinoutDevices } from "src/model/api/nhc-pinout-devices";
import { GetProjectTreeProjectChildNode } from "src/model/api/get-project-tree-project-childnode.model";
import { QuotePrices } from "src/pages/OfferPage/QuotePrices/QuotePrices";
import {
  useGetAllManufacturerDiscountForProjectQuery,
  useGetManufacturerRecommendationForProjectQuery
} from "src/api/v1/manufacturer-discount-ApiSlice";
import { ProjectQuoteFloorVisibility, setAllFloors } from 'src/api/project-quote-ui-slice';
import { GetProjectTreeProject } from 'src/model/api/get-project-tree-project.model';
import { GetVersionResponse } from 'src/model/version.model';
import { FeatureFlagResponse } from 'src/model/api/feature-flag.model';
import { QuoteData } from 'src/model/api/quote-data.model';
import { GetQuoteResponse } from 'src/model/api/quote/get-quote-response.model';
import { CoverImage } from 'src/model/api/cover-image.model';
import { GetRoutingLinesResponse } from 'src/model/api/get-routing-lines-response.model';
import { ProjectQuoteUserProperties } from 'src/model/api/project.model';
import { GroupedElement } from 'src/model/api/grouped-elements.model';
import { GetAllManufacturerDiscountForProjectResponse } from 'src/model/api/manufacturer-discount.model';
import { CableListDevice } from "src/model/api/cable-list-device.model";
import { TwoColumnPageBase } from 'src/components/PageBase/TwoColumnPageBase';
import { QuoteDownloadButton } from "src/pages/OfferPage/QuoteDownloadButton/QuoteDownloadButton";
import { EXPORTED_OFFER_DIV_ID } from "src/utils/constants";
import { GetQuoteCustomItemRecommendationRequest } from "src/model/api/get-quote-custom-item-recommendation.model";
import { Product } from "src/model/product.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { CustomSections } from "src/pages/OfferPage/CustomSections/CustomSections";
import { JumpToUpButton } from 'src/pages/OfferPage/JumpToTopButton/JumpToTopButton';
import AppHeader from 'src/components/AppHeader/AppHeader';
import { floorV2ApiSlice, useGetFloorsQuery } from 'src/api/v2/floor-v2-ApiSlice';
import { useCreateAutomaticallyElectricalAndRackCabinetMutation } from 'src/api/v1/device-ApiSlice';
import { useGetDevicesQuery } from 'src/api/v2/device-v2-ApiSlice';
import { useGetMyProductsQuery } from 'src/api/v2/user-custom-items-v2-ApiSlice';
import { FloorData, getAndTransformSvgData, PlannerInitBundle } from 'src/utils/documentationUtils';
import { showSnackBar } from 'src/api/ui-slice';
import { plannerUiSlice } from 'src/api/planner-ui-slice';
import { ts } from 'src/utils/translate';
import { MissingCabinetDialog } from 'src/pages/OfferPage/MissingCabinetDialog/MissingCabinetDialog';

enum LightingStatus {
  WaitingToLoad = 'waiting_to_load',
  DlStarted = 'dl_started',
  Success = 'success',
  DlError = 'dl_error',
}

interface FloorQuerySubscription { unsubscribe: () => void }

interface LightingFloorState { status: LightingStatus; url: string | null }
type LightingState = { [floorId: number]: LightingFloorState } | null;

export default function OfferPage() {

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const state = useOfferPageState();

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const [ensureCabinets] = useCreateAutomaticallyElectricalAndRackCabinetMutation();

  const confirmCabinets = () => {
    ensureCabinets(Number(state.params.projectId)).then((response) => {
      if (!('data' in response) || response.data?.status !== 1) {
        dispatch(showSnackBar({ text: ts('auto_add_cabinet_failed', 'Could not add the electrical and rack cabinet automatically.'), severity: 'error' }));
      }
      // read-only users can't create cabinets, but the page must still load
    }).finally(() => state.markCabinetsEnsured());
  };

  const cabinetsAutoPlacedRef = useRef(false);

  const floorSubscriptionsRef = useRef<Map<number, FloorQuerySubscription[]>>(new Map());
  useEffect(() => () => {
    floorSubscriptionsRef.current.forEach((subscriptions) =>
        subscriptions.forEach((subscription) => subscription.unsubscribe()));
    floorSubscriptionsRef.current.clear();
  }, []);


  useEffect(() => {
    if (state.shouldAutoPlaceCabinets && !cabinetsAutoPlacedRef.current) {
      cabinetsAutoPlacedRef.current = true;
      confirmCabinets();
    }
  }, [state.shouldAutoPlaceCabinets]);

  useEffect(() => {
    if (state.projectTreeProject == null) {
      return;
    }
    syncProjectQuoteUiSlice(state.projectTreeProject, state.floorVisibilities, dispatch);
    syncFloorSubscriptions(dispatch, state.projectTreeProject, floorSubscriptionsRef.current);
  }, [dispatch, state.floorVisibilities, state.projectTreeProject]);

  if (state.allQueriesReturned && isEveryFloorQueried(state.projectTreeProject!!)) {
    let converter = new QuoteConverter(state.projectQuoteUserProperties!!);
    // QuoteConverter will modifiy quote objects and redux wouldn't allow it
    let tables = converter.respToTables(deepCopy(state.quote!!), state.params.projectId!!, true, state.projectTreeProject!!);

    let floorPlans = getEveryFloorPlans(state.projectTreeProject!!);

    let devicesOfEveryFloor = getDevicesFromEveryFloor(floorPlans);

    // state.svgsData is generated asynchronously off-screen in useOfferPageState; null until ready.
    let {nonRoomTables} = getTablesNewFormat(
        tables,
        state.svgsData,
        state.lightingCalcs,
        state.projectTreeProject!!,
        state.projectQuoteUserProperties!!
    );

    const rows: any = getBomRows(tables, state.projectQuoteUserProperties!!);
    let labourCost = calculateLabourCost(
        rows,
        state.projectQuoteUserProperties!!.selected_currency,
        state.quote!!.work_hour_prices,
        state.quote!!.icon_work_minutes
    );

    const margin = {top: -5, right: -5, bottom: -5, left: -5};
    const width = 960 - margin.left - margin.right;
    const height = 500 - margin.top - margin.bottom;
    const mounted = true // TMP const, comes from docu's index.js
    const pinoutData: undefined | boolean | PinoutData = convertToPinoutData(
        deepCopy(state.installationCabling!!),
        getNetworkDevices(deepCopy(state.quote!!)),
        mounted
    );
    const nhcPinoutData: NHCPinoutDevices = deepCopy(state.nhcPinoutDevices!!);
    const cableListDeviceData: CableListDevice[] | undefined = deepCopy(state.cableListDevices);
    const groupedDevicesData: GroupedElement[] | undefined = deepCopy(state.groupedElements);

    return (
        <>
        <div
            id="fake-maincontainer"
            className="quote-wrapper"
            style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden', left: -99999, top: -99999 }}
        />
        <TwoColumnPageBase
            leftContent={
              <>
                {getDocuSectionButtons(tables, state.svgsData, devicesOfEveryFloor, pinoutData, nhcPinoutData, cableListDeviceData, groupedDevicesData)}
              </>
            }
            pageContent={
              <div ref={scrollContainerRef} style={{ height: '100%', width: '100%', overflowY: 'auto' }}>
                <div id={EXPORTED_OFFER_DIV_ID}>
                  <QuoteDownloadButton
                      projectId={+(state.params.projectId!!)}
                      isPro={state.version!!.is_pro}
                  ></QuoteDownloadButton>

                  {state.projectQuoteUserProperties!!.include_header === 1 ?
                      <QuoteHeader quoteData={state.quoteData!!}/> : null}

                  <ProjectName
                      project={state.projectTree!!.find((project) => project.projectId === Number(state.params.projectId))!!}/>

                  {state.projectQuoteUserProperties!!.include_cover_page === 1 ?
                      <CoverPage coverImages={state.coverImages!!}/> : null}
                  {state.projectQuoteUserProperties!!.include_general_information === 1 ?
                      <QuoteGeneralInfo generalInfo={state.quote!!["project-base"]?.general_info}/> : null}
                  <FunctionDescription
                      functionDescription={state.quote!!["offer-item-desc"]}
                      clientType={state.projectQuoteUserProperties!!.include_client_type}
                  />
                  {getTableSvgOrganizer(tables, state.svgsData)}
                  {getCustomSections(nonRoomTables)}
                  {getNhcData(nhcPinoutData, pinoutData, cableListDeviceData, width, height, groupedDevicesData)}
                  {getCabalLabel(devicesOfEveryFloor)}
                  {getDocuBom(tables)}
                  {getNonRoomTables(nonRoomTables, labourCost)}
                  {getQuotePrices(rows, tables)}

                  <JumpToUpButton scrollRef={scrollContainerRef} />
                </div>
              </div>
            }
        />
        </>
    );
  } else {
    return (
        <>
          <AppHeader />
          <MissingCabinetDialog
              open={state.showCabinetDialog}
              onConfirm={confirmCabinets}
              onCancel={() => navigate(`/planner/${state.params.projectId}`)}
          />
        </>
    );
  }

  function getCabalLabel(devicesOfEveryFloor: GetFloorRoomsDevice[]) {
    return state.projectQuoteUserProperties!!.include_cable_labels === 1 ?
        <CableLabel
            enabled={true}
            devices={devicesOfEveryFloor}
            routingLines={state.routingLines!!}
            projectTreeNodes={state.projectTreeProject!!}/>
        : null;
  }


  function getNhcData(nhcPinoutData: NHCPinoutDevices, pinoutData: PinoutData | undefined | boolean, cableListDeviceData: CableListDevice[] | undefined, width: number, height: number, groupedDevicesData: GroupedElement[] | undefined) {
    return state.projectQuoteUserProperties!!.include_pinout === 1 ?
        <>
          <NHCPinout
              projectId={state.params.projectId}
              nhcPinoutData={nhcPinoutData!!}
          />
          <Pinout
              projectId={state.params.projectId}
              pinoutData={pinoutData!!}
              nhcPinoutData={nhcPinoutData!!}
              cablelist={cableListDeviceData!!}
          />
          <NHCBusPinout
              projectId={state.params.projectId}
              nhcPinoutData={nhcPinoutData!!}
              width={width}
              height={height}
          />
          <GroupedElementsList
              saveGroupedName={state.saveGroupNameByUgroupId}
              groupedDevicesData={groupedDevicesData!!}
              width={width}
              height={height}
              projectId={state.params.projectId!!}
          />
        </>
        : null;
  }

  function getDocuSectionButtons(tables: any[], svgs: any, devicesOfEveryFloor: GetFloorRoomsDevice[], pinoutData: PinoutData | undefined | boolean, nhcPinoutData: NHCPinoutDevices, cableListDeviceData: CableListDevice[] | undefined, groupedDevicesData: GroupedElement[] | undefined) {
    return <DocuSectionButtons
        tableData={tables}
        svgData={svgs}
        projectId={+(state.params.projectId!!)}
        quoteUserProperties={state.projectQuoteUserProperties!!}
        floorVisibilities={state.floorVisibilities!!}
        projectTreeNodes={state.projectTreeProject!!}
        isPro={state.version!!.is_pro}
        isBelgianUser={state.isBelgianUser!!}
        quote={state.quote!!}
        devices={devicesOfEveryFloor}
        pinoutData={pinoutData}
        nhcPinoutData={nhcPinoutData}
        cableListData={cableListDeviceData}
        groupedDevicesData={groupedDevicesData}
        featureFlag={state.featureFlag!!}
        lightingCalcs={state.lightingCalcs}
    />;
  }

  function getDocuBom(tables: any[]) {
    return state.projectQuoteUserProperties!!.include_bom === 1 ?
        <DocuBom
            quoteResponse={state.quote!!}
            workHourPrices={state.quote!!.work_hour_prices}
            tableData={tables}
            currency={state.projectQuoteUserProperties!!.selected_currency}
            currencyVisibility={
              state.projectQuoteUserProperties!!.include_currency_visibility
            }
            bomEnabled={state.projectQuoteUserProperties!!.include_bom === 1}
            quoteUserProperties={state.projectQuoteUserProperties!!}
        />
        : null;
  }

  function getQuotePrices(rows: any, tables: any) {
    return state.quote && state.allManufacturerDiscountForProject && rows &&
    rows.devices && Array.isArray(rows.devices) &&
    rows.services && Array.isArray(rows.services)
        ? (
            <QuotePrices
                projectId={state.params.projectId}
                tableData={tables}
                quote={state.quote}
                allManufacturerDiscountForProject={state.allManufacturerDiscountForProject}
                manufacturerRecommendationForProject={state.manufacturerRecommendationForProject!!}
                currency={state.projectQuoteUserProperties!!.selected_currency}
                quoteUserProperties={state.projectQuoteUserProperties!!}
            />
        ) : null;
  }

  function getNonRoomTables(nonRoomTables: any[], labourCost: {
    installation: { custom: boolean; minutes: number; hours: number; hourlyRate: number; total: number };
    personalisation: { custom: boolean; minutes: number; hours: number; hourlyRate: number; total: number }
  }) {
    return nonRoomTables &&
    nonRoomTables.find((table) => table.entitytype === "projectcustomtable"
    ) ? (
        <NonRoomTable
            projectId={+(state.params.projectId)}
            key={`projectcustomtable_${
                nonRoomTables.find(
                    (table) => table.entitytype === "projectcustomtable"
                ).id
            }`}

            tablesEnabled={state.projectQuoteUserProperties!!.include_tables === 1}
            table={nonRoomTables.find(
                (table) => table.entitytype === "projectcustomtable"
            )}

            roomMapsEnabled={state.projectQuoteUserProperties!!.include_room_map === 1}
            detailsEnabled={state.projectQuoteUserProperties!!.include_item_details === 1}
            dlStarted={false}
            infoButton={true}
            currency={state.projectQuoteUserProperties!!.selected_currency}
            dispatchDownloadStates={null}
            currentRowInEditing={state.currentRowInEditing}
            setCurrentRowInEditing={state.setCurrentRowInEditing}
            labourCostEnabled={state.projectQuoteUserProperties!!.include_currency_visibility >= 1
                && state.projectQuoteUserProperties!!.include_labour_cost === 1}
            labourCost={labourCost}
            measurementSystem={state.measurementSystem!!}
            quoteUserProperties={state.projectQuoteUserProperties!!}
            allManufacturerDiscountForProject={state.allManufacturerDiscountForProject!!}
            manufacturerRecommendationForProject={state.manufacturerRecommendationForProject!!}
            customItemsForRecommendation={state.customItemsForRecommendation!!}
        />
    ) : null;
  }

  function getTableSvgOrganizer(tables: any[], svgs: any) {
    return <TableSvgOrganizer
        projectId={+(state.params.projectId)}
        cameraEnabled={state.projectQuoteUserProperties!!.include_camera_coverage === 1}
        tablesEnabled={state.projectQuoteUserProperties!!.include_tables === 1}
        detailsEnabled={state.projectQuoteUserProperties!!.include_item_details === 1}
        wifiEnabled={state.projectQuoteUserProperties!!.include_wifi_coverage === 1}
        wiringEnabled={state.projectQuoteUserProperties!!.include_wiring === 1}
        roomMapsEnabled={true}
        floorMapsEnabled={true}
        lightingEnabled={state.projectQuoteUserProperties!!.include_lighting === 1}
        lightingCalcs={state.lightingCalcs}
        tables={tables}
        svgs={svgs}
        tableDLStarted={true}
        svgDLStarted={true}
        dispatchDownloadStates={null}
        currentRowInEditing={state.currentRowInEditing}
        setCurrentRowInEditing={state.setCurrentRowInEditing}
        projectTreeNodes={state.projectTreeProject!!}
        measurementSystem={state.measurementSystem!!}
        quoteUserProperties={state.projectQuoteUserProperties!!}
        floorVisibilities={state.floorVisibilities!!}
        allManufacturerDiscountForProject={state.allManufacturerDiscountForProject!!}
        manufacturerRecommendationForProject={state.manufacturerRecommendationForProject!!}
        customItemsForRecommendation={state.customItemsForRecommendation!!}
    />;
  }

  function getCustomSections(nonRoomTables: any) {
    return <CustomSections
        projectId={+(state.params.projectId)}
        nonRoomTables={nonRoomTables}
        detailsEnabled={state.projectQuoteUserProperties!!.include_item_details === 1}
        tablesEnabled={state.projectQuoteUserProperties!!.include_tables === 1}
        currency={state.projectQuoteUserProperties!!.selected_currency}
        currentRowInEditing={state.currentRowInEditing}
        setCurrentRowInEditing={state.setCurrentRowInEditing}
        measurementSystem={state.measurementSystem!!}
        quoteUserProperties={state.projectQuoteUserProperties!!}
        allManufacturerDiscountForProject={state.allManufacturerDiscountForProject!!}
        manufacturerRecommendationForProject={state.manufacturerRecommendationForProject!!}
        customItemsForRecommendation={state.customItemsForRecommendation!!}
    />
  }
}

function useOfferPageState(): {
  token: any,
  floorVisibilities: ProjectQuoteFloorVisibility[] | null,
  params: any
  measurementSystem: string | undefined,
  version: GetVersionResponse | undefined,
  featureFlag: FeatureFlagResponse | undefined,
  projectTree: GetProjectTreeProject[] | undefined
  quoteData: QuoteData | undefined,
  quote: GetQuoteResponse | undefined,
  coverImages: CoverImage[] | undefined,
  currentRowInEditing: any,
  setCurrentRowInEditing: any,
  projectTreeProject: GetProjectTreeProjectChildNode[] | undefined,
  routingLines: GetRoutingLinesResponse | undefined,
  projectQuoteUserProperties: ProjectQuoteUserProperties | undefined,
  installationCabling: InstallationCablingResponse | undefined,
  nhcPinoutDevices: NHCPinoutDevices | undefined,
  cableListDevices: CableListDevice[] | undefined,
  groupedElements: GroupedElement[] | undefined,
  isBelgianUser: boolean | undefined,
  allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse | undefined,
  manufacturerRecommendationForProject: ManufacturerRecommendationResponse | undefined,
  customItemsForRecommendation: Product[] | undefined,
  saveGroupNameByUgroupId: any,
  cabinetsEnsured: boolean,
  showCabinetDialog: boolean,
  shouldAutoPlaceCabinets: boolean,
  markCabinetsEnsured: () => void,
  devicesData: any,
  myProductsData: any,
  floorsData: any,
  svgsData: any,
  lightingCalcs: LightingState,
  allQueriesReturned: boolean,

} {
  const dispatch = useAppDispatch();
  const token = useGetAuthKeyQuery()

  const floorVisibilities: ProjectQuoteFloorVisibility[] | null =
      useAppSelector((state) => state.projectQuoteUi.floorVisibilities);

  const params = useParams<{ projectId: string }>();

  const tokenReady = !!(token.data?.token);

  const [cabinetsEnsured, setCabinetsEnsured] = React.useState(false);
  const canLoadCabinetDependent = tokenReady && cabinetsEnsured;

  const {data: measurementSystem} = useGetMeasurementSystemQuery(+(params.projectId!!), {
    skip: !tokenReady
  })

  const {data: version} = useGetVersionQuery(undefined, {
    skip: !tokenReady
  })

  const {data: featureFlag} = useFeatureFlagQuery(undefined, {
    skip: !tokenReady
  })

  const {data: projectTree} = useGetProjectTreeQuery(undefined, {
    skip: !tokenReady
  })

  const {data: quoteData} = useGetQuoteDataQuery(Number(params.projectId), {
    skip: !canLoadCabinetDependent
  })
  const {data: quote} = useGetQuoteQuery(Number(params.projectId), {
    skip: !canLoadCabinetDependent
  })
  const {data: coverImages} = useGetCoverImagesQuery(Number(params.projectId), {
    skip: !tokenReady
  })
  const [currentRowInEditing, setCurrentRowInEditing] = React.useState({});
  const [svgsData, setSvgsData] = useState<any>(null);
  const [lightingCalcs, dispatchLighting] = useReducer(lightingReducer, null);
  const {data: projectTreeProject} = useGetProjectTreeProjectQuery(Number(params.projectId), {
    skip: !tokenReady
  })

  const {data: routingLines} = useGetRoutingLinesQuery(Number(params.projectId), {
    skip: !canLoadCabinetDependent
  })

  const {data: projectQuoteUserProperties} = useGetProjectQuoteUserPropertiesQuery(Number(params.projectId), {
    skip: !tokenReady
  })

  const {data: installationCabling} = useInstallationCablingQuery(Number(params.projectId), {
    skip: !canLoadCabinetDependent
  })

  const {data: nhcPinoutDevices} = useGetNHCPinoutDevicesQuery(Number(params.projectId), {
    skip: !canLoadCabinetDependent
  })

  const {data: cableListDevices} = useCableListQuery(Number(params.projectId), {
    skip: !canLoadCabinetDependent
  })

  const {data: groupedElements} = useGetGroupedElementsQuery(Number(params.projectId), {
    skip: !canLoadCabinetDependent
  })

  const {data: isBelgianUser} = useIsBelgianUserQuery(Number(params.projectId), {
    skip: !tokenReady
  })

  const {data: allManufacturerDiscountForProject} = useGetAllManufacturerDiscountForProjectQuery(Number(params.projectId), {
    skip: !tokenReady
  })

  const {data: manufacturerRecommendationForProject} = useGetManufacturerRecommendationForProjectQuery(Number(params.projectId), {
    skip: !tokenReady
  })

  const {data: devicesData} = useGetDevicesQuery(Number(params.projectId), {
    skip: !tokenReady
  })
  const {data: myProductsData} = useGetMyProductsQuery(undefined, {
    skip: !tokenReady
  })
  const {data: floorsData} = useGetFloorsQuery({project_id: Number(params.projectId)}, {
    skip: !tokenReady
  })

  const [saveGroupNameByUgroupId, {isLoading: isUpdating}] = useSaveGroupNameByUgroupIdMutation()


  const {data: customItemsForRecommendation} = useGetQuoteCustomItemRecommendationQuery(
      {
        project_id: Number(params.projectId),
        search_string: '',
        get_all: true,
      } as GetQuoteCustomItemRecommendationRequest,
      {
        skip: !tokenReady
      }
  )

  // to trigger rerender when any of the floor queries finished
  useAppSelector((state) => state.app.queries)

  const allFloorsQueried = projectTreeProject != null && isEveryFloorQueried(projectTreeProject);
  const cabinetsMissing = allFloorsQueried && areCabinetsMissingInProject(getEveryFloorPlans(projectTreeProject!!));

  useEffect(() => {
    if (!cabinetsEnsured && allFloorsQueried && !cabinetsMissing) {
      setCabinetsEnsured(true);
    }
  }, [cabinetsEnsured, allFloorsQueried, cabinetsMissing]);

  const firstWalkthroughOfferPending = useAppSelector((state) => state.plannerUi.firstWalkthroughOfferPending);
  const [isFirstWalkthroughOffer] = useState(firstWalkthroughOfferPending);
  useEffect(() => {
    if (isFirstWalkthroughOffer) {
      dispatch(plannerUiSlice.actions.setFirstWalkthroughOfferPending(false));
    }
  }, [isFirstWalkthroughOffer, dispatch]);

  const showCabinetDialog = !cabinetsEnsured && cabinetsMissing && !isFirstWalkthroughOffer;
  const shouldAutoPlaceCabinets = !cabinetsEnsured && cabinetsMissing && isFirstWalkthroughOffer;

  const markCabinetsEnsured = () => setCabinetsEnsured(true);

  const allQueriesReturned = version != null && quoteData != null && quote != null && coverImages != null
      && projectTreeProject != null && routingLines != null && projectQuoteUserProperties != null
      && installationCabling != null && nhcPinoutDevices != null && cableListDevices != null
      && groupedElements != null && isBelgianUser != null && allManufacturerDiscountForProject != null
      && manufacturerRecommendationForProject != null && customItemsForRecommendation != null;

  // Generate the floor-plan / wiring / wifi / camera SVGs off-screen once every
  // query has returned, the floors are loaded and the planner inputs are ready.
  useEffect(() => generateOfferSvgs({
    svgsData, allQueriesReturned, projectTreeProject, devicesData, myProductsData,
    floorsData, token, routingLines, projectId: params.projectId, setSvgsData, dispatch,
  }), [svgsData, allQueriesReturned, devicesData, myProductsData, floorsData, token,
    projectTreeProject, routingLines, params.projectId, dispatch]);

  // Once the floor SVGs exist, seed a per-floor lighting download state, then fetch
  // each floor's lighting heatmap serially (matches legacy Documentation.jsx).
  useEffect(() => {
    seedLightingDownloadState({ svgsData, lightingCalcs, projectTreeProject, dispatchLighting });
  }, [svgsData, lightingCalcs, projectTreeProject]);

  useEffect(() => downloadNextFloorLighting({
    svgsData, lightingCalcs, includeLighting: projectQuoteUserProperties?.include_lighting, dispatchLighting,
  }), [svgsData, lightingCalcs, projectQuoteUserProperties]);


  return {
    token,
    floorVisibilities,
    params,
    measurementSystem,
    version,
    featureFlag,
    projectTree,
    quoteData,
    quote,
    coverImages,
    currentRowInEditing,
    setCurrentRowInEditing,
    projectTreeProject,
    routingLines,
    projectQuoteUserProperties,
    installationCabling,
    nhcPinoutDevices,
    cableListDevices,
    groupedElements,
    isBelgianUser,
    allManufacturerDiscountForProject,
    manufacturerRecommendationForProject,
    customItemsForRecommendation,
    saveGroupNameByUgroupId,
    cabinetsEnsured,
    showCabinetDialog,
    shouldAutoPlaceCabinets,
    markCabinetsEnsured,
    devicesData,
    myProductsData,
    floorsData,
    svgsData,
    lightingCalcs,
    allQueriesReturned,
  }
}

function lightingReducer(state: LightingState, action: any): LightingState {
  if (action.type === 'init') return action.init;
  if (state == null) return state;
  return {
    ...state,
    [action.id]: {
      ...state[action.id],
      status: action.status,
      ...(action.url !== undefined ? { url: action.url } : {}),
    },
  };
}

function generateOfferSvgs(input: {
  svgsData: any,
  allQueriesReturned: boolean,
  projectTreeProject: GetProjectTreeProjectChildNode[] | undefined,
  devicesData: any,
  myProductsData: any,
  floorsData: any,
  token: any,
  routingLines: GetRoutingLinesResponse | undefined,
  projectId: string | undefined,
  setSvgsData: (svgs: any) => void,
  dispatch: AppDispatch,
}): (() => void) | void {
  const { svgsData, allQueriesReturned, projectTreeProject, devicesData, myProductsData,
    floorsData, token, routingLines, projectId, setSvgsData, dispatch } = input;
  if (svgsData != null || !allQueriesReturned) return;
  if (projectTreeProject == null || !isEveryFloorQueried(projectTreeProject)) return;
  const providersReady = devicesData != null && myProductsData != null
      && floorsData != null && token?.data?.yiiEnv != null;
  if (!providersReady) return;

  const floorIds = getFloorIds(projectTreeProject);
  const floorHTMLs = getEveryFloorHtmls(projectTreeProject);
  const floorPlans = getEveryFloorPlans(projectTreeProject);
  const floorDatas: FloorData[] = floorIds.map((floorId, i) => ({
    projectId: Number(projectId),
    floorId: Number(floorId),
    floorHTML: floorHTMLs[i],
    floorPlan: floorPlans[i],
  }));
  const initBundle: PlannerInitBundle = {
    devicesData,
    myProductsData,
    floorsData,
    env: token.data!!.yiiEnv,
    userRoleInProject: '',
  };

  let cancelled = false;
  getAndTransformSvgData(Number(projectId), floorDatas, routingLines!!.svgs, initBundle)
      .then((result) => {
        if (cancelled) return;
        setSvgsData(result);
        if (!result.plannerSVGs.length && !result.roomSVGs.length) {
          dispatch(showSnackBar({ text: ts('docu_maps_empty', 'There are no maps in this project.'), severity: 'info' }));
        }
      })
      .catch((error) => console.error('Offer floor plan generation failed', error));
  return () => { cancelled = true; };
}

function seedLightingDownloadState(input: {
  svgsData: any,
  lightingCalcs: LightingState,
  projectTreeProject: GetProjectTreeProjectChildNode[] | undefined,
  dispatchLighting: React.Dispatch<any>,
}): void {
  const { svgsData, lightingCalcs, projectTreeProject, dispatchLighting } = input;
  if (lightingCalcs != null || svgsData == null || projectTreeProject == null) return;
  const floorIds = getFloorIds(projectTreeProject).map(Number);
  const init: { [floorId: number]: LightingFloorState } = {};
  floorIds.forEach((id) => (init[id] = { status: LightingStatus.WaitingToLoad, url: null }));
  dispatchLighting({ type: 'init', init });
}

function downloadNextFloorLighting(input: {
  svgsData: any,
  lightingCalcs: LightingState,
  includeLighting: number | undefined,
  dispatchLighting: React.Dispatch<any>,
}): (() => void) | void {
  const { svgsData, lightingCalcs, includeLighting, dispatchLighting } = input;
  if (lightingCalcs == null || svgsData == null) return;
  if (includeLighting !== 1) return;
  if (Object.values(lightingCalcs).some((v) => v.status === LightingStatus.DlStarted)) return;
  const floorIdKey = Object.keys(lightingCalcs).find(
      (id) => (lightingCalcs as any)[id].status === LightingStatus.WaitingToLoad);
  if (floorIdKey == null) return;
  const floorId = Number(floorIdKey);

  dispatchLighting({ id: floorId, status: LightingStatus.DlStarted });
  const engine = new LightingCalcTransfer(
      svgsData.gatheredRooms, svgsData.gatheredLengthOf1Px, svgsData.gatheredFloorIdToRooms);
  let cancelled = false;
  engine.fetchCanvasB64(floorId)
      .then((url: string) => { if (!cancelled) dispatchLighting({ id: floorId, status: LightingStatus.Success, url }); })
      .catch(() => { if (!cancelled) dispatchLighting({ id: floorId, status: LightingStatus.DlError }); })
      .finally(() => { if (typeof engine.stopBackgroundTasks === 'function') engine.stopBackgroundTasks(); });
  return () => { cancelled = true; };
}

function syncFloorSubscriptions(
    dispatch: AppDispatch,
    projectTreeProject: GetProjectTreeProjectChildNode[],
    subscriptions: Map<number, FloorQuerySubscription[]>
) {
  const floorIds = getFloorIds(projectTreeProject);

  floorIds.forEach((floorId) => {
    if (subscriptions.has(floorId)) {
      return;
    }
    subscriptions.set(floorId, [
      dispatch(floorApiSlice.endpoints.getFloor.initiate(floorId)),
      dispatch(floorV2ApiSlice.endpoints.getFloorRoomsAndRelatedObjects.initiate(floorId))
    ]);
  });

  subscriptions.forEach((floorSubscriptions, floorId) => {
    if (floorIds.includes(floorId)) {
      return;
    }
    floorSubscriptions.forEach((subscription) => subscription.unsubscribe());
    subscriptions.delete(floorId);
  });
}

function isEveryFloorQueried(projectTreeProject: GetProjectTreeProjectChildNode[]): boolean {
  let floorIds = getFloorIds(projectTreeProject);

  for (const floorId of floorIds) {
    let isFloorSuccess = floorApiSlice.endpoints.getFloor.select(floorId)(store.getState() as RootState).isSuccess;
    let isFloorRoomSuccess = floorV2ApiSlice.endpoints.getFloorRoomsAndRelatedObjects.select(floorId)(store.getState() as RootState).isSuccess;
    if (!isFloorSuccess || !isFloorRoomSuccess) {
      return false;
    }
  }
  return true;
}

function getEveryFloorHtmls(projectTreeProject: GetProjectTreeProjectChildNode[]): string[] {
  let floorHTMLs: string[] = [];
  let floorIds = getFloorIds(projectTreeProject);

  for (const floorId of floorIds) {
    let floorHTML = floorApiSlice.endpoints.getFloor.select(floorId)(store.getState() as RootState).data!!;
    floorHTMLs.push(floorHTML)
  }
  return floorHTMLs;
}

function getEveryFloorPlans(projectTreeProject: GetProjectTreeProjectChildNode[]): GetFloorRoomsAndRelatedObjectsResponse[] {
  let floorPlans: GetFloorRoomsAndRelatedObjectsResponse[] = [];
  let floorIds = getFloorIds(projectTreeProject);

  for (const floorId of floorIds) {
    let floorPlan = floorV2ApiSlice.endpoints.getFloorRoomsAndRelatedObjects.select(floorId)(store.getState() as RootState).data!!;
    if (floorPlan != null) {
      floorPlans.push(floorPlan)
    }
  }
  return floorPlans;
}

function areCabinetsMissingInProject(floorPlans: GetFloorRoomsAndRelatedObjectsResponse[]): boolean {
  let hasElectrical = false;
  let hasRack = false;
  for (const floorPlan of floorPlans) {
    for (const item of (floorPlan.additional_items ?? []) as Array<{ type?: string }>) {
      if (item.type === 'electrical cabinet') hasElectrical = true;
      if (item.type === 'rack cabinet') hasRack = true;
    }
  }
  return !hasElectrical || !hasRack;
}

function getDevicesFromEveryFloor(floorPlans: GetFloorRoomsAndRelatedObjectsResponse[]): GetFloorRoomsDevice[] {
  let devices: GetFloorRoomsDevice[] = [];
  for (const floorPlan of floorPlans) {
    if (floorPlan.devices != null) {
      for (const device of floorPlan.devices) {
        devices.push(device);
      }
    }
  }
  return devices;
}

function syncProjectQuoteUiSlice(
    projectTreeProject: GetProjectTreeProjectChildNode[],
    floorVisibilities: ProjectQuoteFloorVisibility[] | null,
    dispatch: AppDispatch) {
  const floors = getFloors(projectTreeProject)
  const nextFloorVisibilities = floors.map((floor) => {
    return floorVisibilities?.find((floorVisibility) => floorVisibility.floorId === floor.floorId)
        ?? {
          floorId: floor.floorId,
          floorPlanVisible: true,
          roomFloorPlansVisible: true,
          dropDownOpened: false
        } as ProjectQuoteFloorVisibility
  })

  const unchanged = floorVisibilities != null
      && floorVisibilities.length === nextFloorVisibilities.length
      && nextFloorVisibilities.every((floorVisibility, index) => floorVisibility === floorVisibilities[index]);
  if (unchanged) {
    return;
  }

  dispatch(setAllFloors(nextFloorVisibilities));
}